import { SelectionList, Text } from '@dixa/lib-shared-habla';
import type {
  SearchFilterConditionCustomAttribute,
  SearchFilterConditionCustomAttributeField,
  SearchFilterOperator,
} from 'lib-search-types';
import { SearchFilterLayout, SearchFilterOptions } from 'lib-search-ui';
import { useCallback } from 'react';

import { CustomFieldAttribute } from 'apis/customFields';

const textOperators = ['is_empty', 'is_not_empty'] as const;

type SearchCustomAttributesFilterTextProps = {
  field: SearchFilterConditionCustomAttributeField;
  attribute: CustomFieldAttribute;
  condition: SearchFilterConditionCustomAttribute | undefined;
  onChange: (
    condition: SearchFilterConditionCustomAttribute | null,
    attributeId: string,
  ) => void;
  onBack: () => void;
};

export function SearchCustomAttributesFilterText({
  field,
  attribute,
  condition,
  onChange,
  onBack,
}: SearchCustomAttributesFilterTextProps): JSX.Element {
  const selectedOperator = condition?.operator as
    | SearchFilterOperator
    | undefined;

  const handleChangeOperator = useCallback(
    (newOperator: SearchFilterOperator) => {
      onChange(
        {
          field,
          operator: newOperator,
          values: [],
          attributeId: attribute.id,
        } as SearchFilterConditionCustomAttribute,
        attribute.id,
      );
    },
    [attribute.id, field, onChange],
  );

  const handleClear = useCallback(() => {
    onChange(null, attribute.id);
  }, [attribute.id, onChange]);

  return (
    <>
      <SearchFilterLayout.Row>
        <Text.Paragraph variant="3" subdued>
          {attribute.label}
        </Text.Paragraph>
      </SearchFilterLayout.Row>

      <SearchFilterLayout.Row noPadding>
        {/* Wrapping `BackItem` in an inactive `SelectionList` enables hover state. */}
        <SelectionList isActive={false}>
          <SelectionList.BackItem onSelected={onBack} />
        </SelectionList>
      </SearchFilterLayout.Row>

      <SearchFilterLayout.Row borderTop>
        <SearchFilterOptions
          isDefaultOpen
          operators={textOperators}
          selectedOperator={selectedOperator}
          onChangeOperator={handleChangeOperator}
          onClear={handleClear}
        />
      </SearchFilterLayout.Row>
    </>
  );
}
